/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teary_Steep_Mayfly_LoopInputs */

const fr_teary_steep_mayfly_loop = /** @type {(inputs: Teary_Steep_Mayfly_LoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette catégorie apparaît dans les vitrines publiques`)
};

/**

* @param {Teary_Steep_Mayfly_LoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teary_steep_mayfly_loop = /** @type {((inputs?: Teary_Steep_Mayfly_LoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teary_Steep_Mayfly_LoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teary_steep_mayfly_loop(inputs)
});